import styled from "styled-components";

import { TEXT_PRIMARY } from "../../colors";
import { visuallyHiddenCss } from "../../style-utilities/visually-hidden";
import { Caps, Caption } from "../../typography";
import FieldErrorBase from "../FieldError";
import HelperTextBase from "../HelperText";

export const Fieldset = styled.fieldset`
  * {
    box-sizing: border-box;
  }

  border: 0;
  display: block;
  margin: 0;
  padding: 0;

  &:disabled {
    label {
      &:hover {
        background-color: initial;
        cursor: initial;
      }
    }
  }
`;

export const Legend = styled(Caps).attrs({ as: "legend" })`
  color: ${TEXT_PRIMARY};
  margin: 0 0 6px;
  padding: 0;
`;

export const Error = styled(FieldErrorBase).attrs({ as: "p" })``;

export const Helper = styled(HelperTextBase).attrs({ as: "p" })`
  ${({ isVisuallyHidden }) => isVisuallyHidden && visuallyHiddenCss}
`;

export const Hint = styled(Caption).attrs({ as: "span" })`
  font-weight: 400;
`;
